import { useRef } from 'react';

import { useToggle, IconButton, TDropdownSize } from '@treezor/design-system';

import { AdvancedDropdown, TAdvancedDropdownItem } from '@/ui-kit/dropdown/AdvancedDropdown';

export type TAdvancedActionMenuProps = {
  actions: TAdvancedDropdownItem[];
  className?: string;
  isSelected?: boolean;
  testId?: string;
  size?: TDropdownSize;
};

export function AdvancedActionMenu({ actions, className, isSelected, testId, size }: TAdvancedActionMenuProps) {
  const iconButtonRef = useRef<HTMLButtonElement & HTMLAnchorElement>(null);

  const [isDropdownOpen, toggleDropdown] = useToggle(false);

  return (
    <div className={className}>
      <IconButton
        ref={iconButtonRef}
        icon="more_vert"
        variant="secondary"
        isActive={isDropdownOpen}
        onClick={toggleDropdown}
        className={isSelected ? 'text-icon-onColor' : ''}
        testId={testId}
        size={size}
      />
      {isDropdownOpen && (
        <AdvancedDropdown items={actions} onClose={toggleDropdown} parentRef={iconButtonRef} overflow size={size} />
      )}
    </div>
  );
}
